import {
  setInteractionTabClick,
  setInteractionButtonSendClick,
  setInteractionMoreInfo,
  setInteractionCardClick,
  setInteractionScroll,
  setDisplayedService,
  setInteractionClickComponent,
  setInteractionCloseModal,
} from '.';
import { THttpService } from '@/services/HttpService';

import {
  TDispatchInteracion,
  TDisplayedService,
  TInteractionButtonSendClick,
  TInteractionCardClick,
  TInteractionMoreInfo,
  TInteractions,
  TInteractionScroll,
  TInteractionClickComponent,
  TInteractionTabClick,
  TInteractionCloseModal,
} from './types';

export async function dispatchInteraction<T extends TInteractions>(
  api: THttpService,
  type: TDispatchInteracion,
  params: T,
): Promise<void> {
  const callBacks = {
    'click-component': () =>
      setInteractionClickComponent(api, params as TInteractionClickComponent),
    'tab-click': () =>
      setInteractionTabClick(api, params as TInteractionTabClick),
    'card-click': () =>
      setInteractionCardClick(api, params as TInteractionCardClick),
    'button-send': () =>
      setInteractionButtonSendClick(api, params as TInteractionButtonSendClick),
    'more-info': () =>
      setInteractionMoreInfo(api, params as TInteractionMoreInfo),
    click_modal_close: () =>
      setInteractionCloseModal(api, params as TInteractionCloseModal),
    scroll: () => setInteractionScroll(api, params as TInteractionScroll),
    displayed: () => setDisplayedService(api, params as TDisplayedService),
  };

  await callBacks[type]();
}
